import { render } from "./ValueListField.vue?vue&type=template&id=f3fe5cbc"
import script from "./ValueListField.vue?vue&type=script&lang=js"
export * from "./ValueListField.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValueListField.vue"]])

export default __exports__